import React from "react";
import "../../Styles/ModalCart.css";

const ExamModalCart = ({ image, close, handleRoute, remainedExam }) => {
  return (
    <div className="modal-wrapper">
      <div
        style={{ backgroundColor: "#D8EDFE", justifyContent: "flex-start" }}
        className="ModalCart_box"
      >
        <img style={{ width: "32%" }} src={image} alt="icon image" />
        {/* Allowed number of participants in the exam */}
        <div className="allowed-start-exam-box">
          <div className="title-allowed-exam">
            <img src="/imgs/hisstoriPlus/warning-exam.svg" alt="warning-icon" />
            <h5>اجازه شرکت در این آزمون</h5>
            <div className="content-allowed-exam">
              <h5>{remainedExam} بار</h5>
            </div>
          </div>
        </div>
        <p className="title-allowed-exam-text">مطمئنی می‌خوای شروع کنی؟</p>
        <div className="parent-btns-in-allowed-modal">
          <div onClick={handleRoute} className="success-btn-allowed-modal">
            آره شروع میکنم!
          </div>
          <div onClick={close} className="err-btn-allowed-modal">
            بیخیال، باشه بعدا!
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamModalCart;
